import { environment } from '../../environment'
import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { defaultModalState, ModalType } from './data';

export type ModalData = {
  type: ModalType;
  data?: any;
}

export type UseModalStore = {
  setModalState: (state: ModalType) => void;
  setModalData: (data: any) => void;
  closeModal: () => void;
  openModal: ({ type, data }: ModalData ) => void;
  open?: boolean;
  type?: ModalType;
  data?: any;
}

export const useModal = create<UseModalStore>(
  devtools
    ((set, get) => ({
      setModalState: (state) => ({ state }),
      setModalData: (data) => ({ data }),
      closeModal: () => set({
        open: false,
        data: null,
        type: 'NONE'
      }),
      openModal: ({
        data,
        type
      }) => set({ data, type, open:true }),
      reset:()=> set({...defaultModalState})
    }))
)

export const UserStore = useModal.getState()
